import { render, staticRenderFns } from "./DppOffersView.vue?vue&type=template&id=21ccc0e6&scoped=true&"
import script from "./DppOffersView.vue?vue&type=script&lang=js&"
export * from "./DppOffersView.vue?vue&type=script&lang=js&"
import style0 from "./DppOffersView.vue?vue&type=style&index=0&id=21ccc0e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ccc0e6",
  null
  
)

export default component.exports